import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Chip, ListItemText, MenuItem, MenuList, TableCell, TableRow, Typography } from '@mui/material';
import { messageTableMenuItem } from 'src/styles/MessageListStyle';
import { treatmentChipTextStyle } from 'src/styles/NewLead';
import { useSelector } from '../../redux/store';
import { duplicateTableRowStyle } from '../../styles/NewLeadTableRowStyle';
import { TableMoreMenu } from '../table';
import { Iconify } from '..';

const AudiencePreviewTableRow = ({ row, handleUnsubscribeLead, showStatus }) => {
    const { dateFormat } = useSelector((state) => state.lead);
    const [openMenu, setOpenMenuActions] = useState(null);
    const handleCloseMenu = () => {
        setOpenMenuActions(null);
    };

    const handleUnsubscribe = () => {
        handleCloseMenu();
        handleUnsubscribeLead(row);
    };

    return <TableRow hover sx={duplicateTableRowStyle(row)}>
        <TableCell align='left' sx={{ whiteSpace: 'nowrap' }}>
            <Typography variant="subtitle2" sx={{ display: 'inline-flex' }}>
                <span>{dateFormat === 'date_format' ? moment(row?.created_at, 'DD-MM-YYYY HH:mm:ss').format('DD/MM/YY') : row.created_at_human}</span>
            </Typography>
        </TableCell>
        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
            <Typography variant="subtitle2">
                <span style={{ textTransform: 'capitalize' }}>{row?.first_name || ''} {row?.last_name || ''}</span>
            </Typography>
        </TableCell>
        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
            <Typography variant="subtitle2">
                <span style={{}}>{row?.lead_contact?.email || ''}</span>
            </Typography>
        </TableCell>
        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
            <Typography variant="subtitle2">
                <span style={{}}>{row?.lead_contact?.phone || '-'}</span>
            </Typography>
        </TableCell>
        {showStatus && <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
            <Typography variant="subtitle2">
                <Chip
                    label={row?.is_unsubscribed ? 'Unsubscribed' : 'Subscribed'}
                    sx={treatmentChipTextStyle(!row?.is_unsubscribed ? 'compaign' : '')}
                />
            </Typography>
        </TableCell>}
        {!row?.is_unsubscribed && row?.lead_contact?.email && <TableCell align='right'>
            <TableMoreMenu
                open={openMenu}
                sx={{ width: '200px' }}
                onOpen={(event) => setOpenMenuActions(event.currentTarget)}
                onClose={handleCloseMenu}
                actions={
                    <MenuList>
                        <MenuItem onClick={handleUnsubscribe}>
                            <Iconify icon={'fluent-mdl2:unsubscribe'} />
                            <ListItemText
                                primary='Unsubscribe'
                                primaryTypographyProps={messageTableMenuItem}
                            />
                        </MenuItem>
                    </MenuList>
                }
            />
        </TableCell>}
    </TableRow>;
};

export default AudiencePreviewTableRow;

AudiencePreviewTableRow.propTypes = {
    row: PropTypes.object,
    handleUnsubscribeLead: PropTypes.func,
    showStatus: PropTypes.bool
};